import { Typography } from "@mui/material";
export default function ListagemSemRegistros(props) {
  return (
    <Typography sx={{ m: 2, textAlign: "center" }} variant="h5">
      {props.children || "Nenhum registro para os parâmetros informados!"}
    </Typography>
  );
}
